<script setup lang="ts">
import { useError, clearError, useHead, useRoute, navigateTo } from 'nuxt/app'
import { computed, ref } from 'vue'
import ArrowLeftIcon from '~/assets/svg/arrow-left.svg?component'
import ChevronRightIcon from '~/assets/svg/chevron-right.svg?component'

const error = useError()
const route = useRoute()

const statusCode = computed(() => (error.value as any)?.statusCode || 500)

const titleText = computed(() => {
  if (statusCode.value === 404) return 'Aradığınız sayfayı bulamadık'
  if (statusCode.value === 403) return 'Bu içeriğe erişim izniniz yok'
  return 'Beklenmeyen bir hata oluştu'
})

const subtitleText = computed(() => {
  const path = String(route.path || '')
  if (statusCode.value === 404) {
    if (/^\/[^/]+$/.test(path)) return 'Kurs bulunamadı ya da kaldırılmış olabilir.'
    return 'İstediğiniz sayfa kaldırılmış ya da adresi değişmiş olabilir.'
  }
  if (path === '/' || path === '') return 'Kursları şu anda yükleyemiyoruz. Lütfen daha sonra tekrar deneyin.'
  return 'İçerik şu anda ulaşılamıyor. Lütfen yeniden deneyin.'
})

useHead(() => ({
  title: titleText.value,
  meta: [
    { name: 'robots', content: 'noindex' },
  ],
}))

const loadingHome = ref(false)
const loadingRetry = ref(false)

const goHome = async () => {
  loadingHome.value = true
  await clearError()
  await navigateTo('/')
}
</script>
<template>
  <!--
    This example requires updating your template:

    ```
    <html class="h-full">
    <body class="h-full">
    ```
  -->
  <main class="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
    <div class="text-center">
      <p class="text-base font-semibold text-indigo-600">{{ statusCode }}</p>
      <h1 class="mt-4 text-5xl font-semibold tracking-tight text-balance text-gray-900 sm:text-7xl">{{ titleText }}</h1>
      <p class="mt-6 text-lg font-medium text-pretty text-gray-500 sm:text-xl/8">{{ subtitleText }}</p>
      <div class="mt-10 flex items-center justify-center gap-x-6">
        <button type="button" @click="goHome" class="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Ana Sayfaya Dön</button>
      </div>
    </div>
  </main>
</template>


